import React, { useState } from 'react'
import { BackButton, CancelButton, SubmitButton } from '../../../../Components/Utils/Buttons';
import NuDate from '../../../../Components/Utils/NuDate';
import FormikSelectTwo from '../../../../Components/Utils/Select';
import { NuInput } from '../../../../Components/Utils/Input';
import useAddFormData from '../../../../Components/Hooks/useAddFormData';
import { Link, useNavigate } from 'react-router-dom';
import { useFormik } from 'formik';
import * as yup from 'yup';
import DropDownAddMetaData from '../../../../Components/Utils/selectAddMetaData';
import { useToast } from '../../../../Components/Others/ToastServices';
import Attachement from '../../../../Components/Utils/CustomAttrachmentupload';
import UseCustomerDropDownNew from '../../../../Components/Hooks/useCustomerSearch';
import useFetchMataData from '../../../../Components/Hooks/useFetchMataData';
import MultiSelect from '../../../../Components/Utils/MultiSelect';
import UseDropDown from '../../../../Components/Hooks/useDropDown';
import Breadcrumb from '../../../../Components/Utils/Breadcrumb';
import { SettingHeading } from '../../../../Components/Utils/Settingheading';
const filetype = [
  "docx",
  "doc",
  "xlsx",
  "xls",
  "pdf",
  "txt",
  "pptx",
  "mp4",
  "mov",
  "wmv",
  "avi",
  "flv",
  "mkv",
];

function CreateSchedulesTesting() {
  const navigate = useNavigate();
  const {  addFormData , isLoading} = useAddFormData();
   const toast = useToast();
    const [image, setImage] = useState([]);
   const [selectedFile, setSelectedFile] = useState(null);
      const [searchClient, setSearchClient] = useState("");
   
  const { data: client, setDataCustomer } = UseCustomerDropDownNew(
     "/clients/drop-down",
     searchClient
   );
   const { data: user } = UseDropDown(`/user/new-drop-down`);
   const { data: supplier } = UseDropDown(`/suppliers/drop-down/1`);
   const { data: main } = UseDropDown(`/suppliers/drop-down/2`);

   const { data: installer } = UseDropDown(`/suppliers/drop-down/3`);
   const { data: consultant } = UseDropDown(`/suppliers/drop-down/4`);
   const { data: Conductors } = UseDropDown(`/suppliers/drop-down/5`);


  
   const { value: Status, getData: refStatus } = useFetchMataData(
    `/dropdown/dropdown-details/`,
    "Status_Schedules"
  );
  const { value: Type, getData: refType } = useFetchMataData(
       `/dropdown/dropdown-details/`,
       "Type_Schedules"
     );
     const [createNew, setCreateNew] = useState({
      type:"",
      clientId:null,
      projectName:"",
      mainContractor:null,
      location:"",
      consultant:null,
      date:"",
      status:"",
      supplier:null,
      installer:null,
      conductors:null,
      attachments: [],
      mainContractorName:"",
      consultantName:"",

  });

  function handleImageChange(e) {
    const maxFileSize = 200000000; // 200 MB
    const files = Array.from(e.target.files);
    let fileArr = [];

    files.forEach((item) => {
      if (item.size < maxFileSize) {  
        fileArr.push(item);
      } else {
        toast.open({
          type: "warning",
          message: `File Size too big`,
          description: `${item.name} is removed and not uploaded`,
        });
      }
    });

    setSelectedFile(fileArr);


    setImage(fileArr);
    e.target.value = null;
  }

  const removeImages = (value) => {
    let List = selectedFile.filter((item) => item?.name !== value?.name);
    setSelectedFile([...List]);
    setImage(List);
  };

  const formik = useFormik({
      enableReinitialize: true,
      initialValues: createNew,
      validateOnChange: false,
      validateOnBlur: false,
      validationSchema: yup.object({
        clientId: yup.string().required("Client is required!"),
        projectName: yup.string().required("Project Name is required!"),
        
        
       // phone: yup
       //    .string()
       //    .matches(/^\d+$/, "Phone number must contain only digits")
       //    .min(9, "Phone number must be at least 9 digits")
       //    .max(11, "Phone number must be at most 11 digits")
       //    .required("Phone number is required"),
       //    cPMobile: yup
       //    .string()
       //    .matches(/^\d+$/, "Phone number must contain only digits")
       //    .min(9, "Phone number must be at least 9 digits")
       //    .max(11, "Phone number must be at most 11 digits")
       //    .required("Phone number is required"),
       //  email: yup.string().required("Email is required!"),
       //  companyName: yup.string().required("Company Name is required!"),
       //  // website: yup.string().required("Website is required!"),
       //  cpName: yup.string().required("Contact Person is required!"),
      }),
      onSubmit: async (value, { resetForm }) => {
        // setLoading(true);
        let formData = new FormData();
        const valueWithProducts = {
          ...value,
          // products: productsString,
          // services: servicesString,
          // emails: emailsString,
        };
        formData.append("json_data", JSON.stringify(valueWithProducts));
        // formData.append("attachments", image.raw);
        if (selectedFile !== null) {
          selectedFile.forEach((file) => {
            formData.append("attachments", file);
          });
        } else {
          formData.append("attachments", []);
        }
              await addFormData({url:`/tc-schedules/new-schedule`, formData:formData,navigateUrl:`/Contract-management/schedules`,resetForm:resetForm   });

        // addFormData("/tc-schedules/new-schedule", formData, resetForm);
        // setLoading(false);
      },
    });
 
 

  return (
    <div className=" w-full h-full py-2 px-4 ">
         <div className="flex justify-between w-full"> 
         <Breadcrumb
                  items={[
                    // { name: "Testing&Commissioning" },
                    {   name: "Schedules" ,
                      link:"/Contract-management/schedules"
                    },
                    { name: "Create" },
                  ]}
                />     
        <BackButton />
      </div>
      <form onSubmit={formik.handleSubmit}>
        <div className="w-full mx-auto h-[calc(100vh-145px)] bg-white rounded-xl overflow-hidden mt-4">
          <div className=" w-full h-full flex justify-start content-start flex-wrap py-2 px-4  overflow-y-auto">
            <div className="w-full">
            <SettingHeading title="Schedule "  />
             
            </div>
            <DropDownAddMetaData
              label="Type"
              Options={Type}
              formik={formik}
              placeholder="Choose"
              name="type"
              width="w-full md:w-1/3 md:-mt-2"
              displayProperty={"Type"}
              propertyName={"Type_Schedules"}
                 getFunc={refType}
            />

            <FormikSelectTwo
              label="Client"
              Options={client}
              formik={formik}
              placeholder="Choose"
              name="clientId"
              isRequired={true}

              width="w-full md:w-1/3 md:-mt-2"
            />

             <NuInput
             type="text"
              label="Project Name"
      //         Options={[
      //           { value: "project1", label: "Project X" },
      // { value: "project2", label: "Project Y" },
      //         ]}
              formik={formik}
              placeholder="Choose"
              name="projectName"
              isRequired={true}

              width="w-full md:w-1/3 md:-mt-2"
            />

<FormikSelectTwo
              label="Main Contractor"
              Options={main}
              formik={formik}
              placeholder="Choose"
              name="mainContractor"

              width="w-full md:w-1/3 md:-mt-2"
            />

<FormikSelectTwo
              label="Consultant"
              Options={consultant}
              formik={formik}
              placeholder="Choose"
              name="consultant"

              width="w-full md:w-1/3 md:-mt-2"
            />

<MultiSelect
              label="Conductors"
              Options={user}
              formik={formik}
              placeholder="Choose"
              name="conductors"

              width="w-full md:w-1/3 md:-mt-2"
            />

<FormikSelectTwo
              label="Supplier"
              Options={supplier}
              formik={formik}
              placeholder="Choose"
              name="supplier"

              width="w-full md:w-1/3 md:-mt-2"
            />

<NuInput
              type="date"
              label="Date"
              placeholder="Date"
              formik={formik}
              name="date"
              width="w-full md:w-1/3 md:-mt-2"
            />



<FormikSelectTwo
              label="Installer"
              Options={installer}
              formik={formik}
              placeholder="Choose"
              name="installer"

              width="w-full md:w-1/3 md:-mt-2"
            />
            
            <NuInput
              type="text"
              label="Location"
              placeholder="Location"
              formik={formik}
              name="location"
              width="w-full md:w-1/3 md:-mt-2"
            />
            
             {/* <FormikSelectTwo
              label="Conducted by"
              Options={[
                { value: "John", label: "John" },
      { value: "Jane", label: "Jane" },
              ]}
              formik={formik}
              placeholder="Choose"
              name="Conductedby"
              isRequired={true}

              width="w-full md:w-1/3 md:-mt-2"
            /> */}
           
            <NuDate
              label="Date"
              placeholder="Date"
              formik={formik}
              name="date"
             
              width="w-full md:w-1/3 md:-mt-2"
            />

{/* <DropDownAddMetaData
              label="Status"
              Options={Status}
              formik={formik}
              placeholder="Choose"
              name="status"

              width="w-full md:w-1/3 md:-mt-2"
              displayProperty={"Status"}
              propertyName={"Status_Schedules"}
                 getFunc={refStatus}

            /> */}
           {/* <p className="pb-2 pt-4 px-4 text-sm font-medium text-[#111537] underline decoration-[#3369ff] decoration-2 underline-offset-4">
                  Attachement :
                </p> */}
              <Attachement
                handleChange={handleImageChange}
                preview={image || ""}
                width="w-full"
                label="Attach" 
                multiple={true}
                removeImages={removeImages}
              />
           <div className="w-full  my-4 mt-8 ">
              <div className=" flex justify-end gap-4">
                 <CancelButton
                  handleClick={() => {
                    navigate(-1);
                  }}
                />
                <SubmitButton isLoading={isLoading} />
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>
  );
}

export default CreateSchedulesTesting
